(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["preorder-box"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.boPreorderBound) return;
    window.boPreorderBound = true;

    document.addEventListener('click', function (event) {
      var opener = event.target.closest && event.target.closest('[data-bo-po-open]');
      if (opener) {
        var dialog = document.getElementById(opener.getAttribute('aria-controls'));
        if (!dialog) return;
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
        return;
      }

      var target = event.target;
      if (target && target.matches && target.matches('dialog.bo-po-dialog[open]')) {
        var rect = target.getBoundingClientRect();
        var inside = event.clientX >= rect.left && event.clientX <= rect.right &&
          event.clientY >= rect.top && event.clientY <= rect.bottom;
        if (!inside) target.close();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var open = document.querySelector('dialog.bo-po-dialog[open]');
      if (!open) return;
      event.stopPropagation();
      open.close();
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
